<template>
  <div class="date-condition flex">
    <el-select class="ml-3" v-model="condition" size="small">
      <el-option v-for="item in conditions" :key="item.value" :value="item.value" :label="item.label" />
    </el-select>
    <template v-if="hasSection">
      <div class="flex-1 flex items-center">
        <el-date-picker
          class="ml-3"
          style="width: 128px"
          v-model="startTime"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
        <span class="ml-3">至</span>
        <el-date-picker
          class="ml-3"
          style="width: 128px"
          v-model="endTime"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
    </template>
    <template v-else-if="hasInput">
      <el-date-picker
        class="ml-3 flex-1"
        v-model="value"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        size="small"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>
    </template>
  </div>
</template>

<script>
import { BETWEEN, EQ, GE, GT, INCLUDED, LE, LT, NOT_BETWEEN, NOT_EQ, NOT_NULL, NULL } from '@/assets/js/config/condition-config'

export default {
  name: 'DateCondition',
  data() {
    return {
      conditions: [
        {
          label: '等于',
          value: EQ
        },
        {
          label: '不等于',
          value: NOT_EQ
        },
        {
          label: '晚于',
          value: GT
        },
        {
          label: '晚于等于',
          value: GE
        },
        {
          label: '早于',
          value: LT
        },
        {
          label: '早于等于',
          value: LE
        },
        {
          label: '介于（含等于）',
          value: BETWEEN
        },
        {
          label: '不介于',
          value: NOT_BETWEEN
        },
        {
          label: '为空',
          value: NULL
        },
        {
          label: '不为空',
          value: NOT_NULL
        }
      ],
      value: '',
      startTime: '',
      endTime: ''
    }
  },
  created() {
    this.condition = EQ
  },
  methods: {
    getParam() {
      if (this.hasSection) {
        if (!this.startTime && !this.endTime) {
          throw new Error(`${this.data.optionName}搜索值不能为空`)
        }
        return [this.startTime, this.endTime]
      }
      if (!this.value) {
        throw new Error(`${this.data.optionName}搜索值不能为空`)
      }
      return [this.value]
    },
    getShowText() {
      let label = this.conditions.find(c => c.value === this.condition).label
      if (this.condition === BETWEEN || this.condition === NOT_BETWEEN) {
        return `${this.data.optionName} ${label} ${this.startTime}~${this.endTime}`
      } else if (this.condition === NULL || this.condition === NOT_NULL) {
        return `${this.data.optionName} ${label}`
      } else {
        return `${this.data.optionName} ${label} ${this.value}`
      }
    }
  }
}
</script>

<style scoped></style>
